import { createSlice } from '@reduxjs/toolkit';

export interface AuthInitialStates {
  isLoggedIn: boolean;
  userDetails: UserDetails;
  token: string | null;
  categories: Array<string>;
  organizations: Array<string>;
  source: string;
  sourceEmail: string;
}

export type CompanySize = {
  lower: number;
  upper: number;
};

export type CompanyNature = {
  category: string;
  value: string;
};

export type CompanyOptions = {
  companySize: CompanySize[];
  companyNature: CompanyNature[];
};

export type OnboardingData = {
  isCompleted: boolean;
  lastPageFilled: number; // 1-4
  organization: string;
  isMobileVerified: boolean;
  isEmailVerified: boolean;
  companyNature: CompanyNature;
  companySize: CompanySize;
};

export interface UserDetails {
  _id: string;
  name: string;
  email: string;
  mobile: string;
  locations: string[];
  imageUrl: string;
  categories: string[];
  inviteSuccess?: boolean;
  inviteMessage?: string;
  defaultOptions: CompanyOptions | null;
  onboardingData?: Partial<OnboardingData> | null;
  incidentTypes?: string[];
  observationAreas?: string[];
  severity?: string[];
  occuranceRates?: string[];
  created_at: string;
  bloodGroup?: string;
  signature: string;
  whatsAppNumber?: string;
  whatsAppUpdatesEnabled?: boolean;
  companyLogo?: string;
}

const initialState: AuthInitialStates = {
  isLoggedIn: localStorage.getItem('c360labs/user-details') ? true : false,
  userDetails: {
    _id: '',
    name: '',
    imageUrl: '',
    email: '',
    mobile: '',
    locations: [],
    categories: [],
    defaultOptions: null,
    onboardingData: null,
    created_at: '',
    bloodGroup: '',
    signature: '',
    whatsAppNumber: '',
  },
  token: localStorage.getItem('c360labs/user-details')
    ? // @ts-ignore
      JSON.parse(localStorage.getItem('c360labs/user-details')).access_token
    : null,
  categories: [],
  organizations: [],
  source: '',
  sourceEmail: '',
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    onLogin: (state) => {
      state.isLoggedIn = true;
      state.token = // @ts-ignore
        JSON.parse(localStorage.getItem('c360labs/user-details')).access_token;
    },
    onLogout: (state) => {
      state.isLoggedIn = false;
      localStorage.removeItem('c360labs/user-details');
    },
    saveUserDetails: (state, { payload }) => {
      state.userDetails = payload;
    },
    categories: (state, { payload }) => {
      state.categories = payload;
    },
    organizations: (state, { payload }) => {
      state.organizations = payload;
    },
    updateOrganizationArea: (state, { payload }) => {
      state.userDetails = {
        ...state.userDetails,
        observationAreas: [
          ...(state.userDetails.observationAreas ?? []),
          payload,
        ],
      };
    },
    setInviteSource: (state, { payload }) => {
      state.source = payload;
    },
    setSourceEmail: (state, { payload }) => {
      state.sourceEmail = payload;
    },
  },
});

export const {
  onLogin,
  onLogout,
  saveUserDetails,
  categories,
  organizations,
  updateOrganizationArea,
  setInviteSource,
  setSourceEmail,
} = authSlice.actions;
export default authSlice.reducer;
